<template>
  <v-app-bar elevation="1" color="#ffffff" class="app-bar" app>
    <v-btn
      @click.stop="$root.navigation = !$root.navigation"
      color="white"
      x-small
      class="white--black back-button"
    >
      <v-icon dark>mdi-backburger </v-icon>
    </v-btn>
    <div class="d-flex flex-column pl-4">
      <div class="d-flex align-content-center pt-2">
        <span class="app-bar--icon pr-1">
          <v-icon>{{ $route.meta.icon }}</v-icon>
        </span>
        <span class="app-bar--title">{{ $route.meta.title }}</span>
      </div>
      <div class="app-bar--subtitle">
        {{
          $route.meta.subtitle !== ""
            ? $route.meta.subtitle
            : "Welcome to QS Learning"
        }}
      </div>
    </div>
    <v-spacer></v-spacer>
    <!-- <v-btn icon>
      <v-icon>mdi-bell-outline</v-icon>
    </v-btn> -->
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <!--                <v-avatar v-on="on" size="36px">-->
        <!--                    <img src="https://i.pinimg.com/originals/4c/09/06/4c09067dfd891f0f1ef6da9a461c10e6.jpg"/>-->
        <!--                </v-avatar>-->
        <v-btn
          v-on="on"
          text
          v-if="currentUser().username !== null"
          color="primary"
          >{{ currentUser().name }}</v-btn
        >
      </template>
      <v-list>
        <v-list-item @click="logout">Logout</v-list-item>
        <v-list-item @click="changePassword">Change Password</v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppBar",
  mounted() {
    this.checkPanelType();
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    currentUser() {
      const user = JSON.parse(localStorage.getItem("user"));
      return user;
    },
    checkPanelType() {
      this.isVisible =
        this.$route.meta.panelType == "Student" ||
        this.$route.meta.panelType == "Tutor"
          ? true
          : false;
    },
    logout() {
      localStorage.clear();
      window.location.href = process.env.VUE_APP_QS_WEB_PORTAL;
    },
    changePassword() {
      this.$router.replace({
        name: "change.password",
      });
    },
  },
};
</script>

<style lang="scss">
.app-bar {
  background: rgb(255, 255, 255);

  &--icon {
    color: #656c7d;
  }

  &--title {
    color: #656c7d;
    font-size: 1.2rem;
    font-weight: bold;
  }

  &--subtitle {
    color: rgb(223, 223, 223);
    font-size: 0.7rem;
  }
}

.profile-link {
  text-decoration: none;
}

a {
  text-decoration: none;
}

.tab-btn-style {
  height: 70px;
}

.back-button {
  padding: 20px 5px !important;
}

@media only screen and (max-width: 360px) {
  .v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
    height: 62px !important;
  }
}
</style>
